import { createSelector } from '@ngrx/store';
import { Params } from '@angular/router';
import { getRouterSelectors } from '@ngrx/router-store';
import { getSharedFeatureState } from '../shared.state';

export class RouterSelectors {
  static readonly getRouterState = createSelector(getSharedFeatureState, (state) => state.routerState);
  static readonly selectRouteNestedParams = createSelector(RouterSelectors.getRouterState, (router) => {
    let currentRoute = router?.state?.root;
    let params: Params = {};
    while (currentRoute?.firstChild) {
      currentRoute = currentRoute.firstChild;
      params = {
        ...params,
        ...currentRoute.params,
      };
    }
    return params;
  });

  private static readonly routerSelectors = getRouterSelectors();
  static readonly selectCurrentRoute = RouterSelectors.routerSelectors.selectCurrentRoute;
  static readonly selectFragment = RouterSelectors.routerSelectors.selectFragment;
  static readonly selectQueryParams = RouterSelectors.routerSelectors.selectQueryParams;
  static readonly selectQueryParam = RouterSelectors.routerSelectors.selectQueryParam;
  static readonly selectRouteParams = RouterSelectors.routerSelectors.selectRouteParams;
  static readonly selectRouteParam = RouterSelectors.routerSelectors.selectRouteParam;
  static readonly selectRouteDataParam = RouterSelectors.routerSelectors.selectRouteDataParam;
  static readonly selectUrl = RouterSelectors.routerSelectors.selectUrl;
  static readonly selectTitle = RouterSelectors.routerSelectors.selectTitle;

  static readonly selectRouteNestedParam = (param: string) =>
    createSelector(RouterSelectors.selectRouteNestedParams, (params) => params && params[param]);
}
